import { render, staticRenderFns } from "./DashboardInternalCommercial.vue?vue&type=template&id=5276f4c4"
import script from "./DashboardInternalCommercial.vue?vue&type=script&lang=js"
export * from "./DashboardInternalCommercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports